import { render, staticRenderFns } from "./total-stats.vue?vue&type=template&id=124a36e4"
import script from "./total-stats.vue?vue&type=script&lang=js"
export * from "./total-stats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports